module.exports = __webpack_public_path__ + "img/cpany12.fe142410.png";